﻿import { useNavigate } from "react-router-dom";
import { ShoppingCart, ArrowRightLeft, Hourglass, CheckCircle2, ClipboardList } from "lucide-react";
import CustomTitle from "@/components/desktop/list/title/CustomTitle";
import styles from "./histories-home.module.scss";

const HistoriesHome = () => {
	const navigate = useNavigate();

	const historiesOptions = [
		{
			id: 1,
			title: "Historial de Compras",
			description: "Visualiza el registro completo de todas las compras realizadas",
			icon: ShoppingCart,
			path: "/historiales/compra",
			color: "#2196F3",
		},
		{
			id: 2,
			title: "Historial de Salidas",
			description: "Consulta el historial de todas las salidas de productos entre campos",
			icon: ArrowRightLeft,
			path: "/historiales/salida",
			color: "#FF9800",
		},
		{
			id: 3,
			title: "Historial de En Uso",
			description: "Revisa los productos que se encuentran actualmente en uso",
			icon: Hourglass,
			path: "/historiales/en_uso",
			color: "#9C27B0",
		},
		{
			id: 4,
			title: "Historial de Usos",
			description: "Accede al registro completo de todos los usos de productos realizados",
			icon: CheckCircle2,
			path: "/historiales/usos",
			color: "#7fb02f",
		},
		{
			id: 5,
			title: "Otros Movimientos",
			description: "Visualiza todos los movimientos y ajustes de inventario",
			icon: ClipboardList,
			path: "/historiales/otros_movimientos",
			color: "#607D8B",
		},
	];

	const handleNavigate = (path) => {
		navigate(path);
	};

	return (
		<div>
			<CustomTitle
				title={[
					{ label: "Dashboard", onClick: () => navigate("/") },
					{ label: "Historiales", onClick: () => navigate("/historiales") },
				]}
				subtitle="Selecciona el tipo de historial que deseas consultar"
			/>

			<div className={styles.container}>
				<div className={styles.grid}>
					{historiesOptions.map((option) => {
						const Icon = option.icon;
						return (
							<button
								key={option.id}
								className={styles.card}
								onClick={() => handleNavigate(option.path)}
								style={{ "--card-color": option.color }}
							>
								<div className={styles.iconContainer}>
									<Icon size={48} strokeWidth={1.5} />
								</div>
								<h3 className={styles.title}>{option.title}</h3>
								<p className={styles.description}>{option.description}</p>
							</button>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default HistoriesHome;
